import { Route, Routes, useParams } from 'react-router-dom'
import { useAppState } from '@/app/hooks/useAppState'
import { useEffect } from 'react'
import FinalizedReportPage from './finalized-report-page'

export default function FinalizedReports() {
  const { installationId } = useParams<{ installationId: string }>()
  const { setSelectedInstallationId } = useAppState()

  useEffect(() => {
    if (installationId) {
      setSelectedInstallationId(installationId)
    }
  }, [installationId, setSelectedInstallationId])

  return (
    <Routes>
      <Route path="/:finalizedReportId/" element={<FinalizedReportPage />} />
    </Routes>
  )
}
